import { AiOutlineExclamationCircle } from "react-icons/ai";
import "./errormessage.css";

const ErrorMessage = ({ message }) => {
  return (
    <div className="error-container">
      <AiOutlineExclamationCircle size={15} color={"#d40000"} />
      <p className="error-message">{message}</p>
    </div>
  );
};

export default ErrorMessage;
